import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { createSelector } from "reselect";
import { RootState } from "slices";
import { logoutUser } from "slices/thunk";

interface selectLogoutState {
  isUserLogout: boolean;
}

const Logout: React.FC = () => {
  const dispatch = useDispatch();

  const selectLogout = createSelector(
    (state: RootState) => state.Login as selectLogoutState,
    (login) => ({
      isUserLogout: login.isUserLogout,
    })
  );

  const { isUserLogout } = useSelector(selectLogout);

  React.useEffect(() => {
    (dispatch as (action: ReturnType<typeof logoutUser>) => void)(logoutUser());
  }, [dispatch]);

  return isUserLogout ? <Navigate to="/login" /> : null;
};

export default Logout;
